/* Copyright Information: Created by BuyGroup */
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  card_number: Yup.boolean().required().oneOf([true],"Card number is required"),
  default_card: Yup.boolean().required(),
  card_holder_name: Yup.string().required("Please enter name"),
  cvv: Yup.boolean().required().oneOf([true],"Please enter correct cvv"),
  valid_thru: Yup.boolean().required().oneOf([true],"Please enter correct month and year"),
});

export default validationSchema;
/* Copyright Information: Created by BuyGroup */
